import { Outlet, useSearchParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import apiAsync from 'infrastructure/shared/api/api-async'
import { TopAreaNavigation } from 'infrastructure/Application/components'

type ReduxState = { authentication: { token: string } }

const PrivateRoutes = () => {
  const [searchParams] = useSearchParams()
  const tokenState = useSelector(
    (state: ReduxState) => state.authentication.token
  )

  const tokenUrl = searchParams.get('token')

  apiAsync.setAuthToken(tokenUrl || tokenState)

  if (!tokenUrl && !tokenState) {
    ;(window as Window).location =
      `${window.waAuthenticationUrl}login?redirectOrigin=${window.location.href}`
  }

  return (
    <>
      <TopAreaNavigation />
      <Outlet />
    </>
  )
}

export default PrivateRoutes
